// extracted by mini-css-extract-plugin
export var close_btn = "modal-module--close_btn--VaMpu";
export var container = "modal-module--container--esTSl";
export var flex_container = "modal-module--flex_container---1DMv";
export var img = "modal-module--img--LwlZh";
export var info_container = "modal-module--info_container--8Xrh9";
export var shadow_container = "modal-module--shadow_container--0sLaz";
export var subs_container = "modal-module--subs_container--uG4b5";
export var text = "modal-module--text--1QmlQ";